import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
        type: 'number',
        defaultShow: false,
    },
    {
        label: 'webhookType',
        key: 'WEBHOOK_TYPE',
        type: 'select',
        selectOption: 'webhookTypeCodes',
        defaultShow: true,
    },
    {
        label: 'method',
        key: 'METHOD',
        type: 'select',
        selectOption: 'webhookMethodCodes',
        defaultShow: true,
    },
    {
        label: 'payloadVersion',
        key: 'PAYLOAD_VERSION',
        defaultShow: true,
        customRender: true,
    },
    {
        label: 'registeredAt',
        key: 'REGISTERED_AT',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        label: 'active',
        key: 'ACTIVE',
        type: 'select',
        selectOption: 'boolNumberCodes',
        customRender: true,
        defaultShow: true,
        disableSort: true,
    },
    {
        label: 'url',
        key: 'URL',
        defaultShow: true,
        customStyle: { maxWidth: '280px' },
        customStyleHeader: { maxWidth: '280px' },
    },
    {
        label: 'unregisteredAt',
        key: 'UNREGISTERED_AT',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        label: 'deactivationEmailSentAt',
        key: 'DEACTIVATION_EMAIL_SENT_AT',
        type: 'dateTime',
        defaultShow: false,
    },
];
